/**
 * pcsData — Détection UNIQUE de la présence de données « particules grossières » (pcs).
 *
 * Source de vérité partagée par l'écran (PM10PcsChart) ET l'export PDF (pdfCharts) :
 * la divergence entre une logique écran et une logique export est précisément la cause
 * racine du bug pdf-pm10pcs. Une seule fonction, deux consommateurs.
 *
 * Sémantique confirmée sur le modèle PMReading (`pm10_pcs: Number`, aucune valeur par
 * défaut → le champ peut être ABSENT du document) :
 *   - undefined / null  → donnée absente (le champ n'existe pas sur la reading)
 *   - 0                 → mesure valide (0 particule/litre), surtout PAS une absence
 * On teste donc `!= null` (couvre null ET undefined, laisse passer 0) sur l'ENSEMBLE
 * des readings — jamais sur la seule première (bug latent du guard d'origine, qui
 * masquait tout le graphique si la 1ʳᵉ valeur manquait alors que les suivantes étaient
 * valides).
 */
export function hasPcsData(readings) {
  return Array.isArray(readings) && readings.some(r => r && r.pm10_pcs != null);
}
